<app-backend-status-banner></app-backend-status-banner>
<ng-container *ngIf="isLoaded">
  <app-header></app-header>
  <app-page-name [service]="service" *ngIf="!isPartBDetailView"></app-page-name>
  <router-outlet></router-outlet>
  <app-configurator *ngIf="configuratorEnabled" hidden></app-configurator>
</ng-container>
